import { cn } from "./lib/cn";

const AY_KISALTMALARI = [
  "OCA",
  "ŞUB",
  "MAR",
  "NİS",
  "MAY",
  "HAZ",
  "TEM",
  "AĞU",
  "EYL",
  "EKİ",
  "KAS",
  "ARA",
] as const;

export interface DateBlockProps {
  /** `YYYY-AA-GG` takvim günü — SAAT DİLİMİ ÇÖZÜMLENMEZ, dizeden okunur. */
  date: string;
  className?: string;
}

/**
 * Gün/ay kutusu — mockup Ana Sayfa "Yaklaşan Kritik Tarihler" (12 AĞU).
 *
 * ⚠ `new Date(date).getDate()` KULLANILMAZ: `YYYY-AA-GG` yerel saatte gece yarısı olarak
 * çözülür ve UTC'nin batısındaki bir tarayıcıda gün bir geri kayar — kullanıcı 12 Ağustos'u
 * 11 olarak görür. Dize zaten takvim günü, ayrıştırmaya gerek yok (Ana Sayfa'daki mevcut
 * `gunSayisi`/`ayKisaltmasi` mantığıyla aynı kural, burada kit'e taşındı).
 */
export function DateBlock({ date, className }: DateBlockProps) {
  const gun = date.slice(8, 10);
  const ay = AY_KISALTMALARI[Number(date.slice(5, 7)) - 1] ?? "";
  return (
    <span
      aria-hidden="true"
      className={cn(
        "flex size-11 shrink-0 flex-col items-center justify-center rounded-md bg-primary-soft leading-none text-primary",
        className,
      )}
    >
      <span className="text-lg font-bold tabular-nums">{gun}</span>
      <span className="mt-0.5 text-[11px] font-semibold tracking-wide uppercase">{ay}</span>
    </span>
  );
}
